<template>
	<div>
		<v-card-title>
			<h2 class="ml-1">Podsumowanie projektu</h2>
		</v-card-title>
		<v-card-text>
			<agency-project-summary-data-view/>
			<agency-project-summary-users-view/>
			<agency-project-summary-tasks-view/>
			<agency-project-summary-amounts-view/>
			<v-layout v-if="!roles.isAgencyEmployee()" align-center justify-center>
				<v-btn :disabled="!showFinalReportButton" color="primary" @click="showReport" class="ma-5">
					Podgląd sprawozdania końcowego
				</v-btn>
			</v-layout>
		</v-card-text>
	</div>
</template>

<script>
	import AgencyProjectSummaryDataView from "./components/AgencyProjectSummaryDataView";
	import AgencyProjectSummaryUsersView from "./components/AgencyProjectSummaryUsersView";
	import AgencyProjectSummaryTasksView from "./components/AgencyProjectSummaryTasksView";
	import AgencyProjectSummaryAmountsView from "./components/AgencyProjectSummaryAmountsView";
	import {AgencyFinalReport} from "@/api/generated/AgencyFinalReport";
	import {AgencyProject} from "@/api/generated/AgencyProject";

	export default {
		name: "AgencyProjectSummaryView",

		components: {
			AgencyProjectSummaryAmountsView,
			AgencyProjectSummaryTasksView,
			AgencyProjectSummaryUsersView,
			AgencyProjectSummaryDataView
		},

		data() {
			return {
				contestId: null,
				finalReportStatus: null,
				projectFromUserDepartment: false
			};
		},

		methods: {
			showReport() {
				this.$router.openInNewTab('/view/agency-contest/' + this.contestId + '/final-report/' + this.$route.params.projectId);
			},

			loadFinalReportStatus() {
				AgencyFinalReport.getCurrentState(this, this.$route.params.projectId,
					successResponse => {
						this.finalReportStatus = successResponse.status;
						this.contestId = successResponse.contestId;
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać danych o podsumowaniu", errorResponse);
					}
				);
			},

			loadProjectFromUserDepartmentStatus() {
				if (!this.roles.isAdministrator()) {
					AgencyProject.getUserDepartmentProjectStatus(this, this.$route.params.projectId, successResponse => {
							this.projectFromUserDepartment = successResponse;
						},
						errorResponse => {
							this.$messagesBus.$emit("error", "Nie udało się pobrać danych o departamencie", errorResponse);
						});
				}
			}
		},

		computed: {
			showFinalReportButton() {
				if (this.roles.isAdministrator()) {
					return true;
				} else if (this.roles.isLocalAdministrator()) {
					return this.projectFromUserDepartment;
				} else if (this.roles.isDepartmentEmployee()) {
					return this.projectFromUserDepartment && this.finalReportStatus === 'APPROVED';
				}
				return false;
			}
		},

		created() {
			this.loadFinalReportStatus();
			this.loadProjectFromUserDepartmentStatus();
		}
	};
</script>

<style scoped>

</style>
